import { Breadcrumbs, HorizontalLinkGroup } from 'components/navigation';
import { UserAccess } from 'components/user-access';
import { PageRestricted } from 'pages/errors/page-restricted';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PcnContraventionCodesTab } from './PcnContraventionCodesTab';
import { PcnIssuingAuthoritiesTab } from './PcnIssuingAuthoritiesTab';
import { PcnStatusesTab } from './PcnStatusesTab';
import { PcnStatusCommentsTab } from './PcnStatusCommentsTab';
import { PcnReasonsForContraventionsTab } from './PcnReasonsForContraventionsTab';

const defaultArray = [];

const tabs = [
    { location: "/pcn-admin/settings/contravention-codes", title: "Contravention Codes" },
    { location: "/pcn-admin/settings/issuing-authorities", title: "Issuing Authorities" },
    { location: "/pcn-admin/settings/status", title: "Statuses" },
    { location: "/pcn-admin/settings/status-comments", title: "Status Comments" },
    { location: "/pcn-admin/settings/reasons-for-contraventions", title: "Reasons for Contraventions" }
];

export function PcnSettings({ breadcrumbs = defaultArray }) {
    return (
        <UserAccess
            perform="Internal"
            yes={() => (
                <Fragment>
                    <div className="row">
                        <Breadcrumbs items={breadcrumbs} />
                        <h1>PCN Settings</h1>
                    </div>

                    <div className="row">
                        <div className="spacer-bottom-medium">
                            <HorizontalLinkGroup links={tabs} exactRouteMatch={true}></HorizontalLinkGroup>
                        </div>
                    </div>

                    <div className="row">
                        <Routes>
                            <Route path="contravention-codes" element={<PcnContraventionCodesTab />} />
                            <Route path="issuing-authorities" element={<PcnIssuingAuthoritiesTab />} />
                            <Route path="status" element={<PcnStatusesTab />} />
                            <Route path="status-comments" element={<PcnStatusCommentsTab />} />
                            <Route path="reasons-for-contraventions" element={<PcnReasonsForContraventionsTab />} />
                            <Route path="" element={<Navigate to="/pcn-admin/settings/contravention-codes" replace />} />
                        </Routes>
                    </div>
                </Fragment>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}

PcnSettings.propTypes = {
    breadcrumbs: PropTypes.array
};
